import { render, staticRenderFns } from "./descriptionProvidedBy.vue?vue&type=template&id=4e09f352"
import script from "./descriptionProvidedBy.vue?vue&type=script&lang=js"
export * from "./descriptionProvidedBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports